/**
 * Get Sync Jobs API Contract
 *
 * GET /v1/schools/:schoolId/sync/jobs
 * Retrieve sync jobs for a school.
 */

import { z } from 'zod'
import { PaginationMetaSchema, PaginationParamsSchema } from '../common'
import { SyncJobSchema, SyncJobStatusSchema } from '../../schemas/entities/sync'

/**
 * Request Schema
 */
export const GetSyncJobsRequestSchema = PaginationParamsSchema.extend({
  schoolId: z.string().describe('School public ID'),
  syncType: z.string().optional().describe('Filter by sync type'),
  status: SyncJobStatusSchema.optional().describe('Filter by job status')
})

export type GetSyncJobsRequest = z.infer<typeof GetSyncJobsRequestSchema>

/**
 * Response Schema
 */
export const GetSyncJobsResponseSchema = z.object({
  message: z.string(),
  data: z.array(SyncJobSchema),
  meta: PaginationMetaSchema
})

export type GetSyncJobsResponse = z.infer<typeof GetSyncJobsResponseSchema>
